"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOLRolesAuthHeaders = void 0;
const mol_security_headers_1 = require("./mol-security-headers");
/**
 * User's roles and scope information.
 * Do check the MOLAuth decorator and UserRolesUtils in mol-lib-common for helpers. Documentation at https://confluence.ship.gov.sg/x/eS3ENg
 */
class MOLRolesAuthHeaders {
    constructor(props) {
        Object.assign(this, props);
    }
    static from(headers) {
        return new MOLRolesAuthHeaders({
            [mol_security_headers_1.MOLSecurityHeaderKeys.USER_ROLES]: headers[mol_security_headers_1.MOLSecurityHeaderKeys.USER_ROLES],
        });
    }
}
exports.MOLRolesAuthHeaders = MOLRolesAuthHeaders;
mol_security_headers_1.MOLSecurityHeaderKeys.USER_ROLES;
//# sourceMappingURL=MOLRolesAuthHeaders.js.map